import { Button, FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { FormValidationSummary } from '../../forms/components';
import { Org } from '@/types/user';

interface OrgSelectionStepProps {
  organizations: Org[];
  selectedOrgId: number | null;
  loading: boolean;
  errors?: string[];
  onOrgChange: (id: number) => void;
  onContinue: () => void;
  onLogOut: () => void;
}

const OrgSelectionStep = ({
  organizations,
  selectedOrgId,
  loading,
  errors = [],
  onOrgChange,
  onContinue,
  onLogOut,
}: OrgSelectionStepProps) => (
  <>
    <FormValidationSummary validationErrors={errors} />
    <FormControl fullWidth>
      <InputLabel id="org-select-label">Organization</InputLabel>
      <Select
        disabled={loading}
        labelId="org-select-label"
        value={selectedOrgId ?? ''}
        label="Organization"
        onChange={(e) => onOrgChange(e.target.value as number)}
      >
        {organizations.map((org) => (
          <MenuItem key={org.id} value={org.id}>
            {org.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
    <FormControl sx={{ pt: 4, display: 'flex', flexDirection: 'row', gap: 2 }}>
      <Button
        variant="contained"
        disabled={loading || selectedOrgId === null}
        onClick={onContinue}
      >
        {loading ? 'Processing...' : 'Continue'}
      </Button>
      <Button variant="outlined" disabled={loading} onClick={onLogOut}>
        Log Out
      </Button>
    </FormControl>
  </>
);

export default OrgSelectionStep;
